"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _Link = _interopRequireDefault(require("@react/react-spectrum/Link"));

var _Settings = _interopRequireDefault(require("@react/react-spectrum/Icon/Settings"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _react = _interopRequireDefault(require("react"));

var _adobeIntlReact = require("@adobe/adobe-intl-react");

var _Constants = require("../../constants/Constants");

var _metrics = _interopRequireDefault(require("../../custom-hooks/metrics"));

var localizationStrings = _interopRequireWildcard(require("../viewall/__localization__/ViewAll"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var metrics;

var pushMetrics = function pushMetrics(type, onPreferencesClicked) {
  {
    type === 'viewall' ? metrics.event('viewall.settings.clicked', {
      region: window.config && window.config.region
    }) : onPreferencesClicked();
    metrics.event('flyout.settings.clicked', {
      region: window.config && window.config.region
    });
  }
};

var formattedMessage = function formattedMessage(localeData, key, locale) {
  var localeVal = locale.replace('-', '_');

  if (localeData[localeVal] && localeData[localeVal][key]) {
    return localeData[localeVal][key];
  }

  ;
  return localeData['en_US'][key];
};

var SettingsLink = function SettingsLink(props) {
  var preferences = _PulseUtil.default.getFullUrl('/preferences');

  var className = props.className,
      locale = props.locale,
      label = props.label,
      type = props.type,
      variant = props.variant,
      onPreferencesClicked = props.onPreferencesClicked;
  metrics = (0, _metrics.default)('exc.pulse.components.commons.SettingsLink');
  return _react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.THOUSAND_SECONDS,
    placement: "left",
    trigger: "hover"
  }, _react.default.createElement(_Link.default, (0, _extends2.default)({
    className: className,
    href: type === 'viewall' ? preferences : '#/preferences',
    onClick: function onClick() {
      return pushMetrics(type, onPreferencesClicked);
    }
  }, type !== 'flyout' && {
    target: '_top'
  }), _react.default.createElement(_Button.default, {
    className: "settings-button",
    icon: _react.default.createElement(_Settings.default, null),
    label: label && _react.default.createElement(_adobeIntlReact.FormattedMessage, {
      defaultMessage: "Edit preferences",
      messageId: "preferences"
    }),
    quiet: true,
    variant: variant
  })), _react.default.createElement(_Tooltip.default, {
    style: type === 'flyout' ? {
      visibility: 'visible'
    } : {
      visibility: 'hidden'
    }
  }, formattedMessage(localizationStrings, 'preferences', locale)));
};

var _default = SettingsLink;
exports.default = _default;